/*!
 *
 * Angle - Bootstrap Admin Template
 *
 * Version: 4.8
 * Author: @themicon_co
 * Website: http://themicon.co
 * License: https://wrapbootstrap.com/help/licenses
 *
 */

import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { setAppInjector } from './app/app.module';
import { environment } from './environments/environment';

// Import providers from modules
import { FormsModule } from '@angular/forms';
import {
	provideRouter,
	withInMemoryScrolling,
	withPreloading
} from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { provideToastr } from 'ngx-toastr';
import { provideCore } from './app/core/core.providers';
import { routes } from './app/routes/routes';
import { CustomPreloadingStrategy } from './app/shared/services/custom-preloading-strategy.service';
import { provideShared } from './app/shared/shared.providers';

if (environment.production) {
	enableProdMode();
}

export function getBaseUrl() {
	return document.getElementsByTagName('base')[0].href;
}

const p = bootstrapApplication(AppComponent, {
	providers: [
		provideToastr({
			positionClass: 'toast-bottom-right'
		}),
		// Base URL provider
		{ provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },

		// Core providers
		provideCore(),

		// Shared providers
		provideShared(),

		// Router with features
		provideRouter(
			routes,
			withPreloading(CustomPreloadingStrategy),
			withInMemoryScrolling({
				scrollPositionRestoration: 'enabled'
			})
		),

		// Module-based providers that need conversion
		importProvidersFrom(IonicModule.forRoot(), FormsModule)

		// Direct service providers
	]
});

p.then((appRef) => {
	// Set global injector for backward compatibility
	setAppInjector(appRef.injector);

	// Call app bootstrap hook if it exists
	(<any>window).appBootstrap && (<any>window).appBootstrap();
});
// .catch(err => console.error(err));
